import Quill from 'quill/core';
import SearchInputClipboard from './SearchInputClipboard';

const Theme = Quill.import('core/theme');

// @ts-expect-error
class SearchInputEditorTheme extends Theme {
  declare quill: Quill;

  addModule(name: string) {
    if (name === 'clipboard') {
      const clipboard = new SearchInputClipboard(this.quill);
      // @ts-expect-error
      this.modules[name] = clipboard;
      return clipboard;
    }

    return super.addModule(name);
  }
}

export default SearchInputEditorTheme;
